import { render, staticRenderFns } from "./WarrantyView.vue?vue&type=template&id=06cd0122"
import script from "./WarrantyView.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarrantyView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports